import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wichtige-informationen',
  templateUrl: './wichtige-informationen.component.html',
  styleUrls: ['./wichtige-informationen.component.scss']
})
export class WichtigeInformationenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
